// @ts-nocheck
import { Timestamp } from 'firebase/firestore';

export interface IGSyncTask {
  id: string;
  path: string;
  shopId: string;
  instagramUrl: string;
  status: string;
  createdAt: Timestamp;
  resultsLimit?: number;
}

export interface TransformedPost {
  igPostId: string;
  shortCode: string;
  type: 'Image' | 'Video' | 'Sidecar';
  caption: string;
  displayUrl: string;
  videoUrl?: string;
  images: string[];
  childPosts?: Array<{
    displayUrl?: string;
    videoUrl?: string;
    type: 'Image' | 'Video';
  }>;
  ownerUsername: string;
  timestamp: number;
}

export interface VisitedProfile {
  postCount: number;
  url: string;
  posts?: TransformedPost[];
}

export interface ScraperStatus {
  currentCommand: any;
  status: 'idle' | 'scraping' | 'importing' | 'error';
  progress: {
    collected: number;
    imported: number;
    skipped: number;
  };
  error: string | null;
  currentPageUrl?: string;
  currentUsername?: string | null;
  visitedProfiles?: { [username: string]: VisitedProfile };
  autoMode?: {
    enabled: boolean;
    includeSavedPosts: boolean;
    minDelay: number;
    maxDelay: number;
  };
}

export interface ShopKeyPrompt {
  pending: boolean;
  username: string | null;
  resolved: boolean;
  shopId: string | null;
  cancelled: boolean;
}

export const API_URL = 'https://api.sellox.io/api';

export const BUSINESS_CATEGORIES = [
  { label: 'Fashion/Retail', value: 'fashion-retail' },
  { label: 'Beauty/Cosmetic', value: 'beauty-cosmetic' },
  { label: 'Foods', value: 'groceries' },
  { label: 'Accessories', value: 'accessories' },
  { label: 'Fabrics', value: 'fabrics' },
  { label: 'Home Decor', value: 'home-decor' },
  { label: 'Furniture', value: 'furniture' },
  { label: 'Other', value: 'other' }
];

export const COUNTRIES = [
  { label: 'Nigeria', value: 'NG' },
  { label: 'Ghana', value: 'GH' },
  { label: 'United States', value: 'US' },
  { label: 'United Kingdom', value: 'GB' },
  { label: 'South Africa', value: 'ZA' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Canada', value: 'CA' },
  { label: 'Gambia', value: 'GM' },
];

export const SAVED_COLLECTIONS = [
  {
    name: 'Latest Styles',
    url: 'https://www.instagram.com/jobizzness/saved/latest-styles/17936029169959238/',
    shopId: 'igNxGvftWDGacB9P3q0m',
    color: 'from-pink-500 to-rose-500'
  },
  {
    name: 'Prom & Weddings',
    url: 'https://www.instagram.com/jobizzness/saved/prom-weddings/18085218386014988/',
    shopId: 'MDcuGFQIneamJese8tK5',
    color: 'from-purple-500 to-indigo-500'
  },
  {
    name: 'Latest Trends',
    url: 'https://www.instagram.com/jobizzness/saved/latest-trends/18329300941243668/',
    shopId: 'igNxGvftWDGacB9P3q0m',
    color: 'from-blue-500 to-cyan-500'
  }
];

// Image proxy helpers (same pattern as PinsPage)
const proxyUrlCache = new Map<string, string>();

export const needsProxy = (url: string): boolean => {
  if (!url) return false;
  if (url.includes('firebasestorage') || url.includes('sellox')) return false;
  if (url.includes('instagram') || url.includes('cdninstagram')) return true;
  return false;
};

export const getProxiedUrl = async (url: string): Promise<string> => {
  if (!url) return '';
  if (!needsProxy(url)) return url;

  if (proxyUrlCache.has(url)) {
    return proxyUrlCache.get(url)!;
  }

  try {
    const response = await fetch(`${API_URL}/proxy?url=${encodeURIComponent(url)}`);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    proxyUrlCache.set(url, objectUrl);
    return objectUrl;
  } catch (error) {
    console.error('Error fetching proxied resource:', error);
    return url;
  }
};
